import { Injectable, Testability } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { strictEqual } from 'assert';

//import example from '../../assets/quiz2.json';

declare var numcours: number;
//declare var numeropage: number;


@Injectable({
  providedIn: 'root'
})
export class GfichierService {

  tabPages: any;
  posi: number = -1;
  tabContenu: any;
  title: string = "Titre";
  classe: string = "";
  type: string = "";
  nom: string = "";
  nbPages: number;
  email: string;
  mdp: string;
  nom1: string;
  prenom: string;

  
  token = "";
  login: boolean = false;

  url1 = 'http://sciencesappliquees.com/noncato/';
  url3 = '?template=mobilesommaire';




  constructor(public http: HttpClient) {
    // alert(JSON.stringify(example));
  }//fin constructor

  changerPage(): any {

    //for (let i = 0; i < 90; i++) {
    // alert(i +" "+ localStorage.getItem("c"+i))
    //  }


    //alert(this.nbPages);

    if (this.posi < this.nbPages - 1) {
      //this.storage.setItem("c"+numcours,JSON.stringify(this.tabPages));
      //alert("a"+JSON.stringify(this.tabPages));
      this.posi++;
      return true;
    }
    else
      return false;
  }

  
  
  //retourne la page 
  getTabPage() {

    if (this.tabPages[this.posi][0].posi)
      this.posi = this.tabPages[this.posi][0].posi;

    this.tabPages[0][0].posi = this.posi;

    //localStorage.setItem("c" + numcours, JSON.stringify(this.tabPages));
    this.sauvegarde();

    let lgTab = Object.keys(this.tabPages[this.posi]).length;
    //alert(lgTab);
    let tabArray = [];
    //let tab1 : any; 
    //alert(JSON.stringify(tabPage));

    for (let i = 0; i < lgTab; i++) {
      for (let x in this.tabPages[this.posi][i]) {
        tabArray.push({
          id: i,
          key: x,
          value: this.tabPages[this.posi][i][x]
        });
      }
    }//fin for


    return tabArray;
    // alert(this.route.snapshot.paramMap.get("idp"));

  }

  getJsonPage() {
    this.sauvegarde();
    return this.tabPages[this.posi];
   
  }

  initialiser() {

    localStorage.removeItem("c" + numcours);
    this.posi = -1;
    this.loadJson(" ");


  }

  savePage(tabPage: any) {
    this.tabPages[this.posi] = tabPage;
    //alert(JSON.stringify(tabPage));
    this.sauvegarde();
    //localStorage.setItem("c" + numcours, JSON.stringify(this.tabPages));

  }



  //retourne la page 
  getPrint() {


    let lgTab: number;
    //alert(lgTab);
    let tabArray = [];
    //let tab1 : any; 
    //alert(JSON.stringify(tabPage));

    for (let j = 0; j < this.nbPages; j++) {
      lgTab = Object.keys(this.tabPages[j]).length;
      for (let i = 0; i < lgTab; i++) {
        for (let x in this.tabPages[j][i]) {
          tabArray.push({
            posi: j,
            id: i,
            key: x,
            value: this.tabPages[j][i][x]
          });
        }
      }//fin for
    }//fin for j

    return tabArray;
    // alert(this.route.snapshot.paramMap.get("idp"));

  }

  getValue(posit: number, id: number, key: string) {
    return this.tabPages[posit][id][key];
  }

  getValue2(id: number, key: string) {
    return this.tabPages[this.posi][id][key];
  }


  setValue(text: any, id: number, key: string) {
    this.tabPages[this.posi][id][key] = text;
    this.sauvegarde();
  }



  sauvegarde() {
    localStorage.setItem("c" + numcours, JSON.stringify(this.tabPages));

  }

  addPage() {
    let texte = JSON.parse('[{"text":"aa"},{"code":""}]');

    if (this.posi == this.nbPages - 1)
      this.tabPages.push(texte);
    else {
      // this.tabPages.slice(this.posi,0, texte);
      let j = 0;
      let jsonText: string = "[";
      //texte = '[{"text":"aa"},{"code":""}],';
      texte = '[{"text":"aa"},{"htm":"","css":"","js":""}],';

      //alert(JSON.stringify(this.tabPages[j]));
      for (let i = 0; i < this.nbPages; i++) {
        if (i == this.posi) {
          jsonText = jsonText + texte;
        }
        jsonText = jsonText + JSON.stringify(this.tabPages[i]) + ",";
      }
      //alert(this.tabPages[0]);
      jsonText = jsonText.slice(0, -1);
      jsonText = jsonText + "]";
      // alert(jsonText);
      this.tabPages = JSON.parse(jsonText);

    }
    this.nbPages = Object.keys(this.tabPages).length;
    this.sauvegarde();
  }

  removePage() {
    if (this.nbPages > 1) {

      let j = 0;
      let jsonText: string = "[";
      //alert(JSON.stringify(this.tabPages[j]));
      for (let i = 0; i < this.nbPages - 1; i++) {
        if (i == this.posi) j++;
        if (j < this.nbPages) {
          jsonText = jsonText + JSON.stringify(this.tabPages[j]);
          jsonText = jsonText + ",";
        }
        j++;
      }
      //alert(this.tabPages[0]);
      jsonText = jsonText.slice(0, -1);
      jsonText = jsonText + "]";
      // alert(jsonText);
      this.tabPages = JSON.parse(jsonText);

      this.nbPages = Object.keys(this.tabPages).length;
      if (this.posi == this.nbPages)
        this.posi--;

      this.sauvegarde();
    }
  }



  backPage() {
    // || this.tabPages[this.posi][0]["back"]==false
    if (this.posi < 0) {
      return false;
    } else {
      this.posi--;
      return true
    }

  }

  afterPage() {
    if (this.posi < this.nbPages - 1) this.posi++;
  }


  getTitle() {
    if (this.tabPages[this.posi]) {//si tab non defini
      if (this.posi >= 0)
        if (this.tabPages[this.posi][0].title)
          return this.tabPages[this.posi][0].title;
        else
          return "";

    }
    else {
      return ""
    }


  }//fin getTitle



  getCode(id: number) {
    if (this.posi >= 0)
      return this.tabPages[this.posi][id].code;
    else
      return undefined;

  }//fin getCode

  getCode2(id: number) {
    if (this.posi >= 0)
      return this.tabPages[this.posi][id].code2;
    else
      return undefined;

  }//fin getCode




  setCode2(code: string, id: number) {
    this.tabPages[this.posi][id].code2 = code;
    this.sauvegarde();
    // alert(JSON.stringify(this.tabPages[this.posi]))
  }//fin getCode

  setQuiz(quiz: any, id: number) {
    this.tabPages[this.posi][id].quiz = quiz;
    // alert(JSON.stringify(this.tabPages[this.posi]))
    this.sauvegarde();
  }//fin getCode



  setOutput(code: string, id: number) {
    this.tabPages[this.posi][id].output = code;
    this.sauvegarde();
    // alert(JSON.stringify(this.tabPages[this.posi]))
  }//fin getCode

  getOutput(id: number) {
    if (this.posi >= 0)
      return this.tabPages[this.posi][id].output;
    else
      return undefined;

  }//fin getCode

  setCanvas(code: any, id: number) {
    this.tabPages[this.posi][id].canvas = code;
    // alert(JSON.stringify(this.tabPages[this.posi]))
  }//fin getCode

  setVisiCanvas(visi: boolean, id: number) {
    this.tabPages[this.posi][id].visicanvas = visi;
    // alert(JSON.stringify(this.tabPages[this.posi]))
  }//fin getCode

  /*
  loadJson(url: string) {
  
      //alert(numcours);
      let calcul: number = 600 + numcours;
      let adresse = this.url1 + calcul + this.url3;
  
      return new Promise((resolve, reject) => {
        if (this.tabPages == undefined) {
          this.http.post(adresse, "", {
            headers: new HttpHeaders()
              .set("Content-Type", "application/x-www-form-urlencoded")
          })
            .subscribe(data => {
              //  alert(JSON.stringify(data));
              //alert("aaa");
              this.tabPages = JSON.parse(JSON.stringify(data)); // JSON.parse(JSON.stringify(data));
              this.nbPages = Object.keys(this.tabPages).length;
              //alert(this.nbPages);
  
              //this.changerPage();
              resolve("ok");
            }, error => {
              alert("Erreur : Problème de connexion avec la base de donnée");
            });
        }
        else {
          resolve("ok");
        }
      });
    }//fin loadJson
  */


  loadJson(url: string) {

    //alert(localStorage.getItem("a"))
    //alert(numcours);
    let calcul: number = 600 + numcours;
    let adresse = this.url1 + calcul + this.url3;

    return new Promise((resolve, reject) => {
      let data1 = localStorage.getItem("c" + numcours);
      if (data1 != null) {
        //chaegement en  lical json
        this.tabPages = JSON.parse(data1); // JSON.parse(JSON.stringify(data));
        this.nbPages = Object.keys(this.tabPages).length;
        //alert(data1);
        resolve("ok");
      } else {
        //chargement sur serveur du json
        //alert("jkkj");
        if (this.tabPages == undefined) {
          this.http.post(adresse, "", {
            headers: new HttpHeaders()
              .set("Content-Type", "application/x-www-form-urlencoded")
          })
            .subscribe(data => {
              //  alert(JSON.stringify(data));
              //alert("aaa");
              this.tabPages = JSON.parse(JSON.stringify(data)); // JSON.parse(JSON.stringify(data));
              this.nbPages = Object.keys(this.tabPages).length;
              //alert(this.nbPages);


              //this.changerPage();
              resolve("ok");
            }, error => {
              alert("Erreur : Problème de connexion avec la base de donnée");
            });
        }
        else {
          resolve("ok");
        }
      }

    });//fin promise
  }//fin loadJson



  loadFichier(url: string, type = "file") {

    let url2: string = this.url1 + url + this.url3;

    // url2 = "assets/quiz2.json";
    // alert(url2);
    const params = new FormData();
    params.append('para1', 'value1');
    params.append('type', type);

    return new Promise((resolve, reject) => {
      this.http.post(url2, params, { responseType: 'text' })
        .subscribe(data => {
          // alert(JSON.stringify(data));

          resolve(data);
        }, error => {
          alert(JSON.stringify(error));
        });
    });
  }//fin loadfichier

  seconnecter(email: string, mdp: string, nom: string, prenom: string) {

    this.login = true;

    let url2: string;// = this.url1 +  this.url3;
    url2 = "http://sciencesappliquees.com/templates/php/connexion.php";
    
    this.email = email;
    this.mdp = mdp;
    this.nom1 = nom;
    this.prenom = prenom;
    

    let data = JSON.stringify({ "login": email, "nom":nom ,  "prenom":prenom , "mdp": mdp, "cours": numcours, "json": JSON.stringify(this.tabPages) });

    return new Promise((resolve, reject) => {
      this.http.post(url2, data, { responseType: 'text' })
        .subscribe(data => {
          // alert(JSON.stringify(data));

          resolve(data);
          //alert(data);
          this.tabPages[0][0]["nom"] = nom;
          this.tabPages[0][0]["prenom"] = prenom;
          this.tabPages[0][0]["email"] = email;
          this.tabPages[0][0]["cours"] = numcours;
          
          

        }, error => {
          alert(JSON.stringify(error));
        });
    });
  }//fin seconnecter


  //seconnecter2(tab:any=null) {
  seconnecter2() {
    /*
    if (this.login) {

      let url2: string;// = this.url1 +  this.url3;
      url2 = "http://sciencesappliquees.com/templates/php/connexion.php";

      //if(this.login) {

      //probleme ici
      let data = JSON.stringify({ "login": this.email, "mdp": this.mdp, "nom" : this.nom1 , "prenom" : this.prenom , "cours": numcours, "json": JSON.stringify(this.tabPages) });
      //let data = JSON.stringify({ "login": email, "mdp": mdp, "cours": numcours, "json": JSON.stringify(tab) });
      

      //return new Promise((resolve, reject) => {
        this.http.post(url2, data, { responseType: 'text' })
          .subscribe(data => {
             //alert("ok pour se connecter2");

            //resolve(data);
            if(data!="ok") {
              setTimeout(() => {
                this.seconnecter2();
                alert("Prévenir le professeur -> Problèmes sur le réseau : " );

            
              }, 300);  
            } 
            //alert(data);
            //this.tabPages[0][0]["email"] = email;
            //this.tabPages[0][0]["cours"] = numcours;

          }, error => {
            setTimeout(() => {
              this.seconnecter2();
              alert("Prévenir le professeur -> Problèmes sur le réseau : " +JSON.stringify(error));
          
            }, 300);
          });
     // });
      //}
    }
     */
  }//fin seconnecter2

  seconnecter3(data,phppage) {

    this.login = true;

    let url2: string;// = this.url1 +  this.url3;
    url2 = "http://sciencesappliquees.com/templates/php/php/"+phppage+".php";
    data[0].id_cours = numcours;
    let data1 = JSON.stringify(data);
    //alert(data1);
    return new Promise((resolve, reject) => {
      this.http.post(url2, data, { responseType: 'text' })
        .subscribe(data => {
          //alert(JSON.stringify(data));
          let data1 = JSON.parse(String(data));
          this.token = data1.data;
          //alert(this.token);
          resolve(data1.message);

          

        }, error => {
          resolve("erreur");
          //alert(JSON.stringify(error));
        });
    });
    
  }//fin seconnecter 3

  seconnecter4() {

    if (this.login) {

    let url2: string;// = this.url1 +  this.url3;
      url2 = "http://sciencesappliquees.com/templates/php/php/save.php"
      //if(this.login) {

      //probleme ici
      
      this.tabPages[0][0].id_cours = numcours;
      //alert(JSON.stringify(this.tabPages));
      let json2 = [];
      json2[0] = {
                 data: this.token ,
                 cours: numcours,
                 json: JSON.stringify(this.tabPages)
              };
      
      let data1 = JSON.stringify(json2);
     
     return new Promise((resolve, reject) => {
      //return new Promise((resolve, reject) => {
      this.http.post(url2, data1, { responseType: 'text' })
          .subscribe(data => {
            
            //alert(data);
            resolve(data);

          }, error => {
            //alert("erreur"); 
             alert("Prévenir le professeur -> Problèmes sur le réseau : " +JSON.stringify(error));
             this.seconnecter4();

          });
      });//fin promise
    }//fin if login
  }//fin seconnecter4

  




  /****************
   * 
   *********************/
    seconnecterliste(data1:string) {
      //alert(data1);
     let url2 = "http://sciencesappliquees.com/templates/php/listfile.php";
     return new Promise((resolve, reject) => {
          this.http.post(url2, data1, { responseType: 'text' })
            .subscribe(data => {
               //alert(data);
  
              resolve(data);
              //alert(data);
              //this.tabPages[0][0]["email"] = email;
              //this.tabPages[0][0]["cours"] = numcours;
  
            }, error => {
              alert(JSON.stringify(error));
            });
          });
  
    }//fin seconnecter2
  
/****************
   * 
   *********************/
  chargerfichier(url:string) {
    //alert(data1);
   let url2 = "http://sciencesappliquees.com/activites/"+url;
   //alert(url2);
   return new Promise((resolve, reject) => {
        this.http.get(url2, { responseType: 'text'})
          .subscribe(data => {
            
            resolve(data);
            
          }, error => {
             
            //alert(url2);
            //alert("test"+JSON.stringify(error));
            resolve("erreur");
        
          });
     });
  }//fin seconnecter2

    


}
